import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from './auth.service';
import { Globals } from '../shared/globals';
import { StationDefaultReservedTimes } from '../models/station-default-reserved-times.model';
import { StationReservedTime } from '../models/station-reserved-time.model';
import { BulkStationDefaultReservedTimes } from '../models/bulk-station-default-reserved-times.model';

@Injectable()
export class ReservedTimesService {
  private getDefaultReservedTimesUrl: string;
  private postDefaultReservedTimesUrl: string;
  private postBulkDefaultReservedTimesUrl: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private globals: Globals
  ) {
    this.getDefaultReservedTimesUrl = globals.apiUrl(
      'StationDefaultReservedTimes/{stationId}?connectorId={connectorId}'
    );
    this.postDefaultReservedTimesUrl = globals.apiUrl(
      'StationDefaultReservedTimes'
    );
    this.postBulkDefaultReservedTimesUrl = globals.apiUrl(
      'stations/connectors/default_reserved_time'
    );
  }

  getDefaultReservedTimes(
    stationId: string,
    connectorId: number
  ): Promise<StationDefaultReservedTimes> {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;
        return this.http
          .get(
            this.getDefaultReservedTimesUrl
              .replace('{stationId}', stationId)
              .replace('{connectorId}', connectorId.toString()),
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: basicToken,
              },
            }
          )
          .toPromise()
          .then((response) => {
            return response;
          })
          .catch(this.handleError);
      })
      .catch((err) => {
        return err;
      });
  }

  postDefaultReservedTimes(reservedTimes: StationDefaultReservedTimes) {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;

        return this.http
          .post(this.postDefaultReservedTimesUrl, reservedTimes, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: basicToken,
            },
          })
          .toPromise()
          .then((response) => {
            return response;
          })
          .catch(this.handleError);
      })
      .catch((err) => {
        return err;
      });
  }

  postBulkDefaultReservedTimes(
    bulkReservedTimes: BulkStationDefaultReservedTimes
  ) {
    return this.authService
      .getToken()
      .then((result) => {
        const basicToken = 'Basic ' + result;

        return this.http
          .post(this.postBulkDefaultReservedTimesUrl, bulkReservedTimes, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: basicToken,
            },
          })
          .toPromise()
          .then((response) => {
            return response;
          })
          .catch(this.handleError);
      })
      .catch((err) => {
        return err;
      });
  }

  private handleError(error: any): Promise<any> {
    // console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}
